<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1></h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>

    <div class="real">
      <div class="real_item">
        <div class="real_item_title">完善个人信息</div>
        <div class="real_item_stitle">为给您提供更好的预约服务体验</div>
        <div class="real_item_block">
          <div class="real_block real_block_border">
            <div class="real_block_title">姓名</div>
            <input class="real_block_input" type="text" maxlength="12" v-model="input_name" placeholder="请输入您的姓名" />
            <div class="clearboth"></div>
          </div>
          <div class="real_block">
            <div class="real_block_btn">
              <div @click="switchSex(1)" :class="[{'real_block_btn_itemSelect':input_sex==1},'real_block_btn_item']">先生</div>
              <div @click="switchSex(2)" :class="[{'real_block_btn_itemSelect':input_sex==2},'real_block_btn_item']">女士</div>
              <div class="clearboth"></div>
            </div>
          </div>
          <div class="real_blockM real_block_border real_block_margin">
            <div class="real_block_title">生日</div>
            <div class="real_block_birth">{{input_birth}}</div>
            <div @click="selectDate()" class="real_block_icon"></div>
            <div class="clearboth"></div>
          </div>
          <div class="real_submit" @click="submitInfo()">确&nbsp;认</div>
        </div>
      </div>
    </div>

    <div v-show="datapick" @click="selectDate()" class="real_mask"></div>
    <div v-show="datapick" class="real_cont">
      <van-datetime-picker v-model="currentDate" type="date" title="请选择出生日期" :min-date="minDate" :max-date="maxDate" @confirm="confirmDate" @cancel="cancelDate"/>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        input_name:'',//输入姓名
        input_birth:'',//选择生日
        input_sex:1,//用户性别，1：男；2：女
        datapick:false,
        minDate: new Date(1940, 1, 1),
        maxDate: new Date(),
        currentDate: new Date('1990-01-01'),
      }
    },
    created() {
      sessionStorage.setItem('fullpage',this.$route.params.initialswipe)
    },
    mounted() { },
    methods: {
      // 实名确认
      submitInfo(){
        var $this=this
        // console.log(this.input_name)
        // console.log(this.input_birth)
        // console.log(this.input_sex)
        if(this.input_name.length==0){
          $this.$toast('请输入用户姓名')
          return
        }
        if(this.input_birth.length==0){
          $this.$toast('请选择出生日期')
          return
        }
        // realNameSystem
        let param = {
          token: localStorage.getItem("token"),
          name: this.input_name,
          birthday: this.input_birth,
          sex: this.input_sex
        }
        var qs = require('qs');

        let url = this.api.userApi.realNameSystem
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.code==0) {
            $this.$store.commit('updataMyInfo',null)
            $this.$router.go(-1)
            sessionStorage.setItem('realName','yes')
          } else {
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
        })
      },
      // 切换用户性别
      switchSex(sex){
        this.input_sex=sex
      },
      // 选择日期
      selectDate(){
        this.datapick=!this.datapick
      },
      // 确认日期
      confirmDate(e){
        var year=e.getFullYear()
        var month=e.getMonth()+1
        var date=e.getDate()
        if(month<10){
          month='0'+month
        }
        if(date<10){
          date='0'+date
        }
        this.input_birth=year+'-'+month+'-'+date
        this.selectDate()
      },
      // 取消日期
      cancelDate(){
        this.selectDate()
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .container{
    width: 100%;
    height: 100vh;
    background: #FFFFFF;
    .real{
      width: 100%;
      padding: 20*@vm_base 32*@vm_base 0 32*@vm_base;
      .real_item{
        width: 100%;
        padding:50*@vm_base 32*@vm_base 0 32*@vm_base;
        .real_item_title{
          width: 100%;
          font-size: 36*@vm_base;
          font-weight: 500;
          color: #444054;
          padding: 10*@vm_base 0;
        }
        .real_item_stitle{
          width: 100%;
          font-size: 28*@vm_base;
          font-weight: 400;
          color: #8F8C98;
        }
        .real_item_block{
          padding: 68*@vm_base 0 0 0;
          width: 100%;
          .real_block{
            padding: 22*@vm_base 0;
            .real_block_title{
              width: 25%;
              float: left;
              font-size: 28*@vm_base;
              font-weight: 400;
              color: #333333;

              height: 38*@vm_base;
              line-height: 38*@vm_base;
            }
            .real_block_input{
              float: left;
              width: 75%;
              font-size: 28*@vm_base;
              font-weight: 400;
              color: #999999;

              height: 38*@vm_base;
              line-height: 38*@vm_base;
            }
            .real_block_btn{
              padding-left: 25%;
              // padding-top: 32*@vm_base;
              .real_block_btn_item{
                width: 140*@vm_base;
                border-radius: 6*@vm_base;
                border: 1*@vm_base solid #999999;
                font-size: 28*@vm_base;
                font-weight: 400;
                color: #999999;
                text-align: center;
                padding: 16*@vm_base 0;
                float: left;
                margin-right: 60*@vm_base;
              }
              .real_block_btn_itemSelect{
                border: 1*@vm_base solid #444054;
                color: #444054;
              }
            }
          }
          .real_blockM{
            padding: 24*@vm_base 0;
            .real_block_title{
              width: 25%;
              float: left;
              height: 44*@vm_base;
              font-size: 28*@vm_base;
              font-weight: 400;
              color: #333333;
              line-height: 44*@vm_base;

            }
            .real_block_birth{
              float: left;
              width: calc(75% - 88*@vm_base);
              height: 44*@vm_base;
              font-size: 28*@vm_base;
              font-weight: 400;
              color: #333333;
              line-height: 44*@vm_base;
            }
            .real_block_icon{
              float: left;
              width: 88*@vm_base;
              height: 44*@vm_base;
              background-image: url(../../assets/images/base/calendar.png);
              background-position: right center;
              background-size: 44*@vm_base;
              background-repeat: no-repeat;
            }
          }
          .real_submit{
            width: 100%;
            background: #444054;
            border-radius: 12*@vm_base;
            text-align: center;
            padding: 27*@vm_base 0;
            margin-top: 60*@vm_base;
            font-size: 32*@vm_base;
            font-weight: 500;
            color: #FFFFFF;
          }
          .real_block_border{
            border-bottom: 1*@vm_base solid #ebebeb;
          }
          .real_block_margin{
            margin-top: 20*@vm_base;
          }
        }
      }
    }
  }
  .real_mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1;
    background: rgba(0,0,0,0.3);
  }
  .real_cont{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    background: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/realname/realname.vue